import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent } from '../page.component';
import { _ } from '../translation-helper';
import { SharedFacade } from '../+state/shared.facade';
import { Subscription, Subject } from 'rxjs';
import {
    TranslateService,
    AppConfigFactory,
    APP_CONFIG,
    ConfiguratorsDataService,
} from '@icc/shared';
import { ConfigurationsService } from '../configurations/configurations.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, takeUntil } from 'rxjs/operators';
import { Product } from '@icc/shared/product';

@Component({
    selector: 'icc-product-features',
    templateUrl: './product-features.component.html',
    styleUrls: ['./product-features.component.scss'],
    standalone: false
})
export class ProductFeaturesComponent extends PageComponent implements OnInit {
    public title = _('CONFIGURATOR|Cechy produktów');

    private subscriptions: Subscription[] = [];

    products!: Product[];
    hiddenPrice = false;
    curLang = this.config()?.CurLang || 'en';
    loaded = false;
    currency = {};
    private unsubscribe$ = new Subject<void>();

    constructor(
        @Inject(APP_CONFIG) public config: AppConfigFactory,
        private configurationsService: ConfigurationsService<'window' | 'door'>,
        private httpClient: HttpClient,
        private sharedFacade: SharedFacade
    ) {
        super();
        this.sharedFacade.currency$.pipe(takeUntil(this.unsubscribe$)).subscribe((currency) => {
            this.currency = currency;
        });
    }

    ngOnInit() {
        this.hiddenPrice =
            this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator;
        this.getAllFeatures();
    }

    async getAllFeatures() {
        const details = this.configurationsService.createSimpleConfiguration(
            this.configurationsService.conf.Current
        );
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = String(urlParams.get('key'));
        const confType = urlParams.get('type') || 'window';
        const confMarketId = urlParams.get('marketId') || '1';
        const confLang = urlParams.get('lang') || 'pl';
        const params: {
            type: string;
            marketId: string;
            lang: string;
        } = {
            type: confType,
            marketId: confMarketId,
            lang: confLang,
        };
        const response = await this.httpClient
            .post<{ products: Product[] }>(
                (this.config().EnvConfig?.remoteHost || window.location.origin) +
                    '/api/configurator/product_features',
                {
                    configuration: details,
                },
                {
                    headers: new HttpHeaders({
                        key: myParam,
                    }),
                    params,
                }
            )
            .pipe(map((data) => data.products))
            .toPromise();
        this.products = response;
        this.loaded = true;
    }
}
